module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-600italic-4624d18c5dd4c89fa2055339db8641ce.woff";